import { render, staticRenderFns } from "./CompanyDataSection.vue?vue&type=template&id=4873d140&"
import script from "./CompanyDataSection.vue?vue&type=script&lang=js&"
export * from "./CompanyDataSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports